export default __webpack_public_path__ + "static/SuisseIntl-Regular-ad6b612bc5dbc7366e0d8d80168d729e.otf";